module.exports = __webpack_public_path__ + "static/media/logo_image_all_3.a329b039.png";